import type { FormikLazyTextInputProps } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'
import { useCallback, useMemo } from 'react'

import { useAvailableComponents } from '../../../hooks/useAvailableComponents'

const OPTIONS_REQUIRING_LEGALENTITY = ['external'] as const
const OPTIONS_ALWAYS_AVAILABLE = ['pseudoExternal', 'internal'] as const
const OPTIONS = [...OPTIONS_REQUIRING_LEGALENTITY, ...OPTIONS_ALWAYS_AVAILABLE]

type Option = (typeof OPTIONS)[number]

export const useOptions = () => {
  const translate = useTranslate()

  const { isUsingLegalEntity } = useAvailableComponents()
  const options = isUsingLegalEntity ? OPTIONS : OPTIONS_ALWAYS_AVAILABLE

  const isOption = useCallback(
    (option: string | undefined): option is Option =>
      options.some((o) => o === option),
    [options],
  )

  const optionsAddOnProps = useMemo(
    (): NonNullable<FormikLazyTextInputProps['optionsAddOnProps']> => ({
      options,
      renderFn: (option: string) => {
        if (!isOption(option)) {
          return '-'
        }
        switch (option) {
          case 'external':
            return translate('internalIdInput.externalPerson')
          case 'pseudoExternal':
            return translate('internalIdInput.pseudoExternalPerson')
          case 'internal':
            return translate('internalIdInput.internal')
        }
      },
    }),
    [options, translate, isOption],
  )

  return { isOption, optionsAddOnProps }
}
